<form class="clare-search" [formGroup]="searchForm" autocomplete="off">
    <mat-form-field appearance="outline">
        <input
            matInput
            id="{{ 'search' + randomIdSuffix }}"
            type="search"
            i18n="@@SHARED.TEXT.SEARCH"
            [placeholder]="placeholder"
            formControlName="search"
        />
    </mat-form-field>
</form>
